import React, { useState } from 'react';
import { Tabs, TabPanel, Flex, Banner, Text } from '@pega/cosmos-react-core';
import ErrorLogs from './ErrorLogs';
import Alerts from './Alerts';
import { useDispatch, useSelector } from 'react-redux';
import { appState } from '../../interfaces/common';
import { resetBannerInfo } from '../../redux/actions';
import styled, { css } from 'styled-components';

const tabs = [
  {
    id: 'ErrorLogs',
    name: 'Error logs',
  },
  {
    id: 'Alerts',
    name: 'Alerts',
  },
];

const StyledBanner = styled(Banner)(
  () => css`
    margin-block: 24px;
    margin-inline: 16px;
  `,
);

const Monitor = () => {
  const [activeTab, setActiveTab] = useState('ErrorLogs');
  const { bannerInfo } = useSelector((state: appState) => state);
  const dispatch = useDispatch();

  const handleTabClick = (data: string) => {
    setActiveTab(data);
  };
  return (
    <>
      {bannerInfo.message && bannerInfo.forMonitorTab && (
        <StyledBanner
          id="banner"
          action={<Text style={{ fontWeight: 'bold' }}>{bannerInfo.message}</Text>}
          variant={bannerInfo.variant}
          messages={[]}
          onDismiss={() => {
            dispatch(resetBannerInfo());
          }}
          heading={bannerInfo.heading}
        />
      )}
      <Flex container>
        <Tabs
          tabs={tabs}
          currentTabId={activeTab}
          onTabClick={handleTabClick}
          type="vertical"
          style={{ width: '15%' }}
        ></Tabs>
        {tabs.map(({ id }) => {
          return (
            <TabPanel tabId={id} key={id} currentTabId={activeTab} data-testid="monitor-tab-panels">
              {activeTab === 'ErrorLogs' && <ErrorLogs />}
              {activeTab === 'Alerts' && <Alerts />}
            </TabPanel>
          );
        })}
      </Flex>
    </>
  );
};

export default Monitor;
